import {RouteContext} from "../../RouteContext";
import {ListPage} from "../common/ListPage";
import {
    Switch,
} from "@fluentui/react-components";
import {useError, useStatePair} from "../../../type/States";
import {Column, Row} from "../common/Layout";
import {HttpClient} from "../../../io/HttpClient";
import { Types} from "../../../type/Types";
import TruncateText from "../common/TruncateText";
import {PlaceIO} from "../../../io/content/place/PlaceIO";
import {PlaceValueObject} from "../../../model/vo/content/place/PlaceValueObject";


export default function List(props: RouteContext) {
    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map<bigint, boolean>())
    const uploadErrorState = useError()

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value)
        acc.set(id, isActive)
        isActiveState.setValue(acc)
    }

    const json = require('json-bigint')({
        alwaysParseAsBig: true,
        useNativeBigInt: true
    })

    const updateIds = async (ids: bigint[], wishState: boolean) => {
        const body = { isActive: wishState }
        const res: bigint[] = []

        try {
            await Promise.all([...ids].map(async (id) => {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/states/${id}`,
                        {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            credentials: 'include',
                            body: Types.asUndefined(body, json.stringify)
                        }
                    )

                    if (response.ok) {
                        res.push(id)
                    } else {
                        throw new Error(await response.text())
                    }
                } catch (error) {
                    // @ts-ignore
                    uploadErrorState.setDefinedValue(error)
                }
            }))

            const message =
                res.length === ids.length ? '전체 수정 성공' :
                    res.length > 0 ? '일부 수정 성공' :
                        '수정 실패'

            console.log(res.map(v => v.toString()))
            alert(message)
            window.location.reload()
        } catch (error) {
            console.error('Update failed:', error)
            alert('수정 실패')
        }
    }

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={PlaceValueObject.description}
                list={PlaceIO.list}
                count={PlaceIO.count}
                delete={PlaceIO.delete}
                updateIds={updateIds}
                postHref={'/admin/places/post'}
                detailHref={item => `/admin/places/${item.id}`}
                editHref={item => `/admin/places/edit/${item.id}`}
                itemValue={(item, key) => {
                    if (key === 'isActive') {
                        const present = isActiveState.value.get(item.id)

                        if (present !== undefined) {
                            return <>
                                <Switch
                                    checked={present}
                                    onChange={(ev, data) =>
                                    {
                                        const id = Number(item.id.toString().split('n')[0])
                                        const body = { isActive: data.checked }

                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places/states/${id}`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: Types.asUndefined({
                                                    isActive: data.checked,
                                                }, json.stringify)
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if(!res){
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                }

                                />
                            </>
                        } else {
                            return <>
                                <Switch
                                    checked={item.isActive}
                                    onChange={(ev, data) =>
                                    {
                                        const id = Number(item.id.toString().split('n')[0])

                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places/states/${id}`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: Types.asUndefined({
                                                    isActive: data.checked,
                                                }, json.stringify)
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if(!res){
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                } />
                            </>
                        }
                    }
                    else if(key === 'placeImageUrl' || key == 'placeUrl' ){
                        return <TruncateText text={item[key] || ''} maxLength={20}/>
                    }
                    else {
                        return undefined
                    }
                }}
                uploadSheetUrls={[
                    { name: '엑셀 생성 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/excel`, method: 'POST' },
                    { name: '엑셀 수정 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/excel`, method: 'PUT'},
                ]}
                downloadSheetUrl={(searchConditions, sortOrders, offset,count) =>
                    HttpClient.buildUrl(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/excel`,
                        searchConditions,
                        sortOrders,
                        count,
                        offset,
                    )}
                downloadSheetExampleUrls={[
                    { name: '생성 액셀 양식', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/excel/example/post`, },
                    { name: '수정 액셀 양식', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/places/excel/example/put`, },
                ]}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                initialSortOrders={[
                    {
                        name: 'exposedAt',
                        order: 'DESC'
                    }
                ]}
            />
        </Column>
    </>
}